module.exports = __webpack_public_path__ + "static/media/invitedFriends_75_100.372c6d79.png";